import { create } from 'zustand';
import { persist } from 'zustand/middleware';

interface SecretTokenState {
  secretToken: string | null;
  setSecretToken: (token: string) => void;
  clearSecretToken: () => void;
}

/**
 * Extract secret token from secretUrl
 * e.g., "https://linkpls.io/manage/abc123" -> "abc123"
 */
export function extractSecretToken(secretUrl: string): string | null {
  const match = /\/manage\/([^/]+)\/?$/.exec(secretUrl);
  return match?.[1] ?? null;
}

export const useSecretTokenStore = create<SecretTokenState>()(
  persist(
    (set) => ({
      secretToken: null,
      setSecretToken: (token): void => {
        set({ secretToken: token });
      },
      clearSecretToken: (): void => {
        set({ secretToken: null });
      },
    }),
    {
      name: 'linkpls-secret-token',
    }
  )
);
